import Vue from "vue";

import _axios from "axios";

//well leave this just incase we need comeback to reconfigure or something
const _host = window.location.host;
const _base = process.env.BASE_URL;
const dynamicUri = window.location.protocol + "//" + _host + _base;

// Create instance of axios
const axios = _axios.create({
  baseURL: dynamicUri,
  withCredentials: true,
});

// ensere we add the definition
axios.defaults.showLoader = true;
axios.defaults.headers.common['Expires'] = 'Sat, 26 Jul 1997 05:00:00 GMT'
axios.defaults.headers.common['Cache-control'] = 'no-cache'

// Add a request interceptor
axios.interceptors.request.use(
  (request) => {
    // eslint-disable-next-line no-param-reassign
    request.config = {
      // may be overwritten in next line
      // always display notification for the following requests
      showToast: ["POST", "PUT", "DELETE"].some(
        (type) => type === request.method.toUpperCase()
      ),
      showLoader: false,
      message: null,
      ...(request.config || {}),
      start: Date.now(),
    };

    if (request.config.showLoader) {
      Vue.$loader.addRequest();
    }

    return request;
  },

  function (error) {
    // Other Errors
    // make sure to complete the reqest befor trying to display a notification
    // on error just cancel all just to be safe
    Vue.$loader.cancelAll();

    if (error.config.showToast || error.config.config.showToast) {
      Vue.$toast.error(error.message);
    }
    throw error;
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    const now = Date.now();
    const request = response.config;

    // be sure to notify the loader of the request completion
    if (request.config.showLoader) {
      Vue.$loader.complete();
    }

    // we still want to see the exception after page load
    if (request.config.showToast) {
      let toastMessage = null;
            if (request.config.message || request.message) {
        toastMessage = request.config.message || request.message || response.data;
            } else if(response.data == 'Please check your email to reset your password!!') {
              toastMessage = "If the email exists, you will receive a password reset link.";
        
            } else if (typeof response.data === 'string' && response.data.trim()) {
              toastMessage = response.data;
            } else {
              toastMessage ="Success";
      }
      Vue.$toast.success(toastMessage);
    }
    return response;
  },

  function (error) {
    let ctx = Vue;
    ctx.$loader.cancelAll();
    function replaceWords(text, replacements) {
  for (const [wrong, correct] of Object.entries(replacements)) {
    text = text.replace(wrong, correct);
  }
  return text;
}

    // Handle session expiration
    if (error.response && error.response.status === 401) {
      const isLoggedIn = Vue.$store.getters["authentication/isLoggedIn"];
      
      if (isLoggedIn) {
        // Try to restore session, let timeout modal handle failure
        Vue.$store.dispatch("authentication/restoreContext").catch(() => {
          Vue.$store.dispatch("authentication/clearAllLogoutData");
        });
      } else {
        // Redirect to login
        if (ctx.$router.currentRoute.name !== 'Login') {
          ctx.$router.push({ name: "Login" }).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              // console.error('Axios interceptor (401) navigation error:', err);
            }
          });
        }
      }
    }

    // Handle redirects
    else if (error.response && error.response.status === 302) {
      if (ctx.$router.currentRoute.name !== 'Login') {
        ctx.$router.push({ name: "Login" }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            // console.error('Axios interceptor (302) navigation error:', err);
          }
        });
      }
    }

    else if (error.response && error.response.data && (typeof error.response.data === "string" || error.response.data instanceof String)) {
      if (error.config.showToast || error.config.config.showToast) {
        Vue.$toast.error(error.response.data);
      }
    }

    else if (error.response && error.response.data && error.response.data.errors) {
      if (error.config.config.showToast || error.config.showToast) {
        for (var propertyName in error.response.data.errors) {
          Vue.$toast.error(
            `${replaceWords(propertyName, {"confirmPassword": "Confirm Password", "organizationId": "Organization Id", 'password': 'Password', 'phoneNumber': 'Phone Number' , 'firstName': 'First Name', 'lastName': 'Last Name'})}: ${error.response.data.errors[propertyName]}`
          );
        }
      }
    } 
    
    else if (error.response && error.response.data && error.response.data.message) {
      if (error.config.showToast || error.config.config.showToast) {
        Vue.$toast.error(error.response.data.message);
      }
    } 
    
    else if (error.response && error.response.data &&  (typeof error.response.data === "object" || error.response.data instanceof Object)
    ) {
      if (error.config.showToast || error.config.config.showToast) {
        for (var propertyName in error.response.data) {
          Vue.$toast.error(
            `${replaceWords(propertyName, {"ConfirmPassword": "Confirm Password", "Organization Id": "Organization ID", "OrganizationID": "Organization ID"})}: ${error.response.data[propertyName][0]}`
          );
        }
      }
    } 
    
    else if (error && (typeof error === "string" || error instanceof String)) {
      if (error.config.showToast || error.config.config.showToast) {
        Vue.$toast.error(error);
      }
    }

    throw error;
  }
);

export default axios;
